import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import PagesHeroSection from '../../../components/pagesHeroSection/pagesHeroSection';
import SEOUpdater from '../../../utils/hoc/SEOUpdater';

import '../immigrationPage/immigrationPage.scss';
import { Col, Row } from 'react-bootstrap';

const LemonLawPage = () => {
  const { t } = useTranslation('lemonLaw');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="services-page">
      <SEOUpdater page="lemonLaw" />
      <PagesHeroSection page={t('pageTitle')} />

      <div className="services-section text-center">
        <div className="container">
          <h2 className="section-title">{t('heroTitle')}</h2>
          <p>
            <Trans i18nKey="intro.p1" t={t} components={{ 1: <b /> }} />
          </p>
          <p>
            <Trans i18nKey="intro.p2" t={t} components={{ 1: <b /> }} />
          </p>
          <div className="underline mx-auto mb-4"></div>
        </div>
      </div>

      <div className="services-content">
        <div className="container">
          <Row>
            <Col md={6}>
              <h3>{t('section1.title')}</h3>
              <ul>
                <li>
                  <p>{t('section1.list.1')}</p>
                </li>
                <li>
                  <p>{t('section1.list.2')}</p>
                </li>
                <li>
                  <p>{t('section1.list.3')}</p>
                </li>
              </ul>
              <p>{t('section1.extra')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('section2.title')}</h3>
              <p>{t('section2.p')}</p>
              <ul>
                <li>
                  <p>
                    <b>{t('section2.list.1')}</b>
                  </p>
                </li>
                <li>
                  <p>
                    <b>{t('section2.list.2')}</b>
                  </p>
                </li>
                <li>
                  <p>
                    <b>{t('section2.list.3')}</b>
                  </p>
                </li>
              </ul>
            </Col>
          </Row>

          <div className="section-footer pt-5">
            <p className="text-center">
              <Trans i18nKey="footer" t={t} components={{ 1: <b /> }} />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LemonLawPage;
